<template>
  <div class="navbar navbar-inverse">
    <div class="navbar-header"></div>
    <div class="clearfix"></div>
    <transition name="slide">
      <div class="navbar-collapse collapse in" v-show="!collapsed">
        <ul class="nav navbar-nav">
          <li v-for="(nav,index) in getSubNav"
              :key='index'
              class="menu-item">
            <router-link :to="nav.path"
                         active-class='current'>
              <span :class="nav.style">{{ nav.title }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navs: [],
        collapsed: false
      }
    },
    methods: {
      toggleCollapsed: function (event) {
        this.collapsed = !this.collapsed;
      }
    },
    computed: {
      getSubNav(){
        let route = this.$route.path.split('/')[1];
        if (this.navs.length >= 2) {
          switch (route) {
            case "company":
              return this.navs[0].sub;
            case 'template':
              return this.navs[1].sub;
            case 'theme':
              return this.navs[2].sub;
          }
        }
        return this.navs;
      }
    },
    created() {
      this.navs = this.$identity.getNav()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/nav-menu.vue